import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SwalAlertService {

  async showTextInputSwal(titulo: string, placeholder: string, confirmButtonText: string, inputValue: string = '', showCancelButton: boolean = true, cancelButtonText: string = 'Cancelar'): Promise<string | null> {
    const { value, isConfirmed } = await Swal.fire({
      title: titulo,
      input: 'text',
      inputPlaceholder: placeholder,
      confirmButtonText: confirmButtonText,
      showCancelButton: showCancelButton,
      cancelButtonText: cancelButtonText,
      inputValue: inputValue,
      inputValidator: (value) => {
        if (!value) return 'Este campo es obligatorio';
        return null;
      },
      didOpen: () => {
        const txt = Swal.getInput();
        if (txt) txt.setAttribute('autocomplete', 'off');
      }
    });

    return isConfirmed ? value : null;
  }
  async mostrarNotificacion(
    titulo: string,
    text: string,
    confirmButtonText: string,
    icon: SweetAlertIcon = 'success',
    timer: number | null = 3000,
    timerProgressBar: boolean = false,
  ): Promise<string | null> {
    const { value, isConfirmed } = await Swal.fire({
      icon: icon,
      title: titulo,
      text: text,
      confirmButtonText: confirmButtonText,
      timer: timer ?? undefined,
      timerProgressBar: timerProgressBar,
      inputValidator: (value) => {
        if (!value) return 'Este campo es obligatorio';
        return null;
      },
    });
    return isConfirmed ? value : null;
  }
  async confirmarTexto(
    text: string,
    icon: any = 'success',
    options?: {
      title?: string;
      confirmButtonText?: string;
      cancelButtonText?: string;
      reverseButtons?: boolean;
      focusCancel?: boolean;
      showCancelButton?: boolean;
    }
  ): Promise<boolean> {
    const result = await Swal.fire({
      title: options?.title ?? 'Confirmación',
      text,
      icon,
      showCancelButton: options?.showCancelButton ?? (options?.cancelButtonText ? true: false), 
      confirmButtonText: options?.confirmButtonText ?? 'OK',
      cancelButtonText: options?.cancelButtonText ?? 'Cancelar',
      reverseButtons: options?.reverseButtons ?? true,
      focusCancel: options?.focusCancel ?? true,
    });

    return result.isConfirmed === true;
  }
}
